import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DeviceDropDownMetaDetails } from '../services/getDeviceDropDownMeta'

export interface DeviceDropDownMetadataState {
  isLoading: boolean
  loadingError: string | undefined
  DeviceDropDownMetadata: DeviceDropDownMetaDetails | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: DeviceDropDownMetadataState = {
  isLoading: true,
  loadingError: undefined,
  DeviceDropDownMetadata: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const CustomDeviceDropDownMetadataState = createSlice({
  name: 'SchdulerListData',
  initialState,
  reducers: {
    DeviceDropDownMetadataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        DeviceDropDownMetadata: undefined,
        httpStatus: 0
      }
    },
    DeviceDropDownMetadataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        DeviceDropDownMetadata: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    DeviceDropDownMetadataErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        DeviceDropDownMetadata: undefined
      }
    }
  }
})

// Actions to export
export const {
  DeviceDropDownMetadataLoadingAction,
  DeviceDropDownMetadataUpdateAction,
  DeviceDropDownMetadataErrorAction
} = CustomDeviceDropDownMetadataState.actions

export default CustomDeviceDropDownMetadataState.reducer
